import { useDispatch, useSelector } from 'react-redux'
import {
  datesStore,
  datesReducer,
  storeApprovedType,
  storePendingType,
  selectApprovedType,
  selectPendingType,
  useFetchOpenDateRequestsQuery,
} from '@gusiberi/shared'
import { useAuthStore } from './authStore'

export {
  datesStore,
  datesReducer,
  storeApprovedType,
  storePendingType,
  selectApprovedType,
  selectPendingType,
}

export const useDatesStore = () => {
  const dispatch = useDispatch()
  const approvedType = useSelector(selectApprovedType)
  const pendingType = useSelector(selectPendingType)
  const { data: openRequests } = useFetchOpenDateRequestsQuery({})
  const { currentUser } = useAuthStore()

  const setApprovedType = (payload: 'past' | 'upcoming') => {
    dispatch(storeApprovedType(payload))
  }
  const setPendingType = (payload: 'past' | 'upcoming') => {
    dispatch(storePendingType(payload))
  }

  const showingUpcoming = pendingType === 'upcoming'

  return {
    approvedType,
    pendingType,
    setApprovedType,
    setPendingType,
    showingUpcoming,
    openRequests,
    currentUser,
  }
}
